import axios from 'axios';

export default {
  namespaced: true,
  state: {
    services: [],
    service: null,
  },
  getters: {
    services(state) {
      return state.services;
    },
    service(state) {
      return state.service;
    },
    complexities(state) {
      return state.service.complexities;
    },
    components(state) {
      return state.service.components;
    },
    addons(state) {
      return state.service.addons;
    },
    addonsEnabled(state) {
      for (const addonName in state.service.addons) {
          if (state.service.addons[addonName].is_enabled === true) {
              return true;
          }
      }

      return false;
    },
    marginTypes(state) {
      return state.service.margin_types;
    },
    retouchTypes(state) {
      return state.service.retouch_types;
    },
    deliveryTypes(state) {
      return state.service.delivery_types;
    },
    deliveryFormats(state) {
      return state.service.delivery_formats;
    },
    deliveryTimes(state) {
      return state.service.delivery_times;
    },
  },
  mutations: {
    SET_SERVICES(state, services) {
      state.services = services;
    },
    SET_SELECTED_SERVICE(state, service) {
      state.service = service;
    },
  },
  actions: {
    async getServices({ commit }) {
      const { data } = await axios.get('services');

      commit('SET_SERVICES', data);
    },
    async setSelectedSerice({ commit }, payload) {
      commit('SET_SELECTED_SERVICE', payload)
    },
  },
};
